import React from "react";
import PropTypes from "prop-types";

import { Menu } from '@mui/material';

const MenuUI = ({ className, menuId, anchorOrigin = {
	vertical: 'bottom',
	horizontal: 'right',
}, transformOrigin = {
	vertical: 'top',
	horizontal: 'right',
}, ...props }) => {
	return (
		<Menu
			className={ className }
			id={ menuId }
			MenuListProps={ {
				'aria-labelledby': menuId,
			} }
			keepMounted
			anchorOrigin={ anchorOrigin }
			transformOrigin={ transformOrigin }
			disableAutoFocusItem
			{ ...props }
		/>
	);
};

MenuUI.propTypes = {
	className: PropTypes.string,
	menuId: PropTypes.string,
	anchorOrigin: PropTypes.object,
	transformOrigin: PropTypes.object,
};

export default MenuUI;